(function () {
    'use strict';

    angular
        .module('app')
        .controller('errorList', errorList);

    errorList.$inject = ['$location', '$scope', '$rootScope', '$timeout', 'records', '$mdDialog'];

    function errorList($location, scope, $rootScope, $timeout, records, $mdDialog) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'errorList';

        scope.errorListDialogShown = false;

        scope.heading = "Errors";
        scope.filesLabel = "Errors";

        scope.onShowErrorList = function (slx) {
            scope.gridOptions.data = [];
            var atLeastOneError = false;
            angular.forEach(slx.list, function (item) {
                if (item.ec != 0) {
                    atLeastOneError = true;
                    // Fixed "lib" constant. Added Error Code Text. Return now has a stand-alone message and a full message.
                    scope.gridOptions.data.push({
                        name: item.filename,
                        library: item.errLibStr, //'lib',
                        errorCode: item.ec,
                        errorCodeText: item.ecEnumStr,
                        errorMessage: item.errStr, //item.errStr.substring(item.errStr.indexOf("Error Message:") + 15, item.errStr.length),
                        errorMessageDebug: item.errFullErrStr //item.errStr,
                    });
                }
            });
            if (atLeastOneError) {
                scope.errorListDialogShown = true;
            }

            $timeout(function () {
                refreshGrid();
            }, 200);
        };

        scope.onErrorListDialogClose = function () {
            // close dialog
            $mdDialog.hide();
        };

        scope.errorListDialogClosed = function () {
        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);

            scope.onShowErrorList(records.slx);
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '15%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '15%', minWidth: '100' },
                { name: 'Error Message', field: 'errorMessage', width: '50%', minWidth: '100' },
                { name: 'Error Code', field: 'errorCode', width: '5%', minWidth: '100' },
                { name: 'Error Code Text', field: 'errorCodeText', width: '5%', minWidth: '100' }
                ],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
